import type { NewHandoff } from '../types/whatsapp';

/** The server returns the cursor 30 s behind its clock (overlap window). */
export const CURSOR_OVERLAP_MS = 30_000;

/**
 * The server's "now" at the moment the cursor was issued, in ms. Handoffs older than
 * this existed before the page loaded, so they must not fire notifications. The
 * browser clock is not used: a skewed clock would drop or replay handoffs.
 */
export const serverNowFromCursor = (cursor: string): number => Date.parse(cursor) + CURSOR_OVERLAP_MS;

/** Handoffs that deserve a notification: newer than `notBeforeMs` and not seen yet, oldest first. */
export const handoffsToNotify = (
  handoffs: NewHandoff[],
  seen: ReadonlySet<number>,
  notBeforeMs: number,
): NewHandoff[] =>
  handoffs
    .filter((h) => !seen.has(h.event_id) && Date.parse(h.created_at) > notBeforeMs)
    .sort((a, b) => a.event_id - b.event_id);
